import { useStore } from "zustand";
import { createStore } from "zustand/vanilla";

interface ICompanyStore {
  actions: {
    getCompanySelection: () => string[];
    setCompanySelection: (selection: string[]) => void;
  };
  selectedCompanyIds: string[];
}

/**
 * Create the Zustand store for managing the company state.
 */
const CompanyStore = createStore<ICompanyStore>()((set, get) => ({
  actions: {
    getCompanySelection: () => get().selectedCompanyIds,
    setCompanySelection: (selection) => {
      set(() => ({ selectedCompanyIds: selection }));
    },
  },
  selectedCompanyIds: [],
}));

/**
 * A custom hook to access the company state.
 */
function useCompanyStore(): ICompanyStore;
function useCompanyStore<Type>(selector: (state: ICompanyStore) => Type): Type;
function useCompanyStore<Type>(selector?: (state: ICompanyStore) => Type) {
  return useStore(CompanyStore, selector!);
}

export { useCompanyStore };
